var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBag = function SvgIconBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.356 5.75a4.75 4.75 0 0 1 9.288 0h3.606c.966 0 1.75.784 1.75 1.75v12a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 19.5v-12c0-.966.784-1.75 1.75-1.75zm2.7-.945a2.75 2.75 0 0 1 4.506.945H9.438c.137-.35.346-.673.617-.945M7.25 7.75v2a1 1 0 1 0 2 0v-2h5.5v2a1 1 0 1 0 2 0v-2H20v11.5H4V7.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBag;